import { useState } from 'react';

export function useEditableTopicFields(
  initialValue, 
  patchEndpoint, 
  fieldName, 
  infoTopicId, 
  axiosInstance, 
  setInfoTopic
) {
  
  const [isSaving, setIsSaving] = useState(false);
  const [isSaved, setIsSaved] = useState(true);
  const [isError, setIsError] = useState(false);

  const handleChange = (e) => {
    setIsSaved(false);
    setIsError(false);
    setInfoTopic((prev) => ({
      ...prev,
      [fieldName]: e.target.value
    }));
  };

  const handleSave = async (value) => {
    const trimmed = value.trim();
    if (!trimmed.length) return;

    setIsError(false);
    setIsSaving(true);
    try {
      const response = await axiosInstance.patch(
        `/knovia/infoTopic/${infoTopicId}/${patchEndpoint}`,
        { [fieldName]: trimmed }
      );
      setInfoTopic((prev) => ({
        ...prev,
        ...response.data
      }));
      setIsSaved(true);
    } catch (err) {
      setIsError(true);
      console.error(err);
    } finally {
      setIsSaving(false);
    }
  };

  return {
    isSaving,
    isSaved,
    isError,
    handleChange,
    handleSave,
  };
}
